/* eslint-disable max-classes-per-file */

export enum ErrorCode {
    AuthorizationRequiredError
}

export class BaseAppError extends Error {
    public name: string;
    public code: ErrorCode;
    public isBaseAppError: boolean = true;
}

export class AuthorizationRequiredError extends BaseAppError {
    name = 'Карта доступна только после авторизации';
    code = ErrorCode.AuthorizationRequiredError;
}

export class WrongCaptchaError extends BaseAppError {

}
